// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.page {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
}
.page .tutorial-link {
  position: fixed;
  bottom: 0;
  right: 0;
  margin: 0 10px 25px 0;
  height: auto;
}
.page .tutorial-link a {
  border: 1px solid chartreuse;
  background-color: #0abf53;
  color: white;
  text-decoration: none;
  font-size: 12px;
  padding: 10px;
}

.main-header {
  box-shadow: 0px 3px 5px rgba(0, 0, 0, 0.2);
  padding: 24px 32px;
  display: flex;
  align-items: center;
  position: relative;
}

.main-header__logo-container {
  flex-grow: 1;
}

.main-header__logo-container__version {
  display: block;
}

.main-header__user-area {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  justify-content: flex-end;
}
.main-header__user-area .line-break {
  width: 100%;
}
.main-header__user-area button {
  margin: 5px 5px -15px 5px;
  background: none !important;
  border: none;
  color: #069;
  font-size: 12px;
  text-decoration: underline;
  text-align: center;
  cursor: pointer;
}

.main-header__user-area__greetings {
  padding-right: 16px;
}

.main-header__user-area__user-name {
  font-weight: bolder;
  color: #0abf53;
}

.main-header__user-area__user-photo {
  border-radius: 50%;
  width: 52px;
  height: 52px;
  outline: 2px solid #0abf53;
  outline-offset: 2px;
}

.content-wrapper {
  display: flex;
  flex-grow: 1;
  height: calc(100% - 10px);
}

.main-container-wrapper {
  flex-grow: 1;
  position: relative;
  overflow: hidden;
  padding: 36px;
}

.menu-toggle-button {
  position: absolute;
  border-top-right-radius: 50%;
  border-bottom-right-radius: 50%;
  width: 72px;
  text-indent: 32px;
  height: 72px;
  border: 0;
  background: #ccc;
  top: 40px;
  left: -36px;
  color: #fff;
  font-size: 20px;
  cursor: pointer;
  transition: all 0.3s;
  line-height: 72px;
}
.menu-toggle-button:hover {
  background-color: #aaa;
}

.main-container__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.main-container__title {
  font-size: 32px;
}

.main-container__search-container {
  width: 400px;
}

.main-content {
  display: flex;
  margin-top: 24px;
  flex-wrap: wrap;
}

.main-content__sidebar {
  width: 300px;
  border-right: 1px solid #ccc;
  padding-right: 40px;
  box-sizing: border-box;
}

.main-content__sidebar__header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.main-content__sidebar__title {
  font-size: 18px;
  font-weight: bold;
  text-transform: uppercase;
}

.filters__title {
  font-size: 18px;
  font-weight: bold;
  margin: 16px 0;
  width: fit-content;
}

.checkbox.filters__checkbox {
  display: flex;
}
.checkbox.filters__checkbox ~ .filters__checkbox {
  margin-top: 8px;
}

.main-content__result {
  flex-grow: 1;
  padding-left: 40px;
  flex-shrink: 0;
  flex-basis: calc(100% - 340px);
}

.modal-input {
  margin-top: 24px;
  margin-bottom: 16px;
}

.modal-buttons-container {
  display: flex;
  gap: 16px;
}
.modal-buttons-container * {
  width: 100%;
}

@media screen and (max-width: 1273px) {
  .main-container-wrapper {
    padding: 20px;
  }
  .main-content {
    flex-direction: column;
    align-items: center;
  }
  .main-container__header {
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  .main-container__search-container {
    margin-top: 20px;
    width: 50%;
  }
  .main-content__sidebar,
  .main-content__result {
    padding: 0;
    width: 100%;
    border: none;
  }
  .main-content__sidebar {
    margin-bottom: 50px;
  }
  .main-content__sidebar__header {
    justify-content: center;
  }
  .main-content__sidebar__header h4 {
    margin-right: 20px;
  }
  .checkbox.filters__checkbox {
    justify-content: center;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/Layout/AuthenticatedLayout.scss","webpack://./src/utils/scss/_variables.scss"],"names":[],"mappings":"AAEA;EACE,aAAA;EACA,sBAAA;EACA,iBAAA;AADF;AAEE;EACE,eAAA;EACA,SAAA;EACA,QAAA;EACA,qBAAA;EACA,YAAA;AAAJ;AACI;EACE,4BAAA;EACA,yBCdU;EDeV,YAAA;EACA,qBAAA;EACA,eAAA;EACA,aAAA;AACN;;AAGA;EACE,0CAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,kBAAA;AAAF;;AAEA;EACE,YAAA;AACF;;AAEA;EACE,cAAA;AACF;;AAEA;EACE,aAAA;EACA,mBAAA;EACA,eAAA;EACA,yBAAA;AACF;AAAE;EACE,WAAA;AAEJ;AAAE;EACE,yBAAA;EACA,2BAAA;EACA,YAAA;EACA,WAAA;EACA,eAAA;EACA,0BAAA;EACA,kBAAA;EACA,eAAA;AAEJ;;AACA;EACE,mBAAA;AAEF;;AAAA;EACE,mBAAA;EACA,cC7Dc;ADgEhB;;AADA;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,0BAAA;EACA,mBAAA;AAIF;;AAFA;EACE,aAAA;EACA,YAAA;EACA,yBAAA;AAKF;;AAFA;EACE,YAAA;EACA,kBAAA;EACA,gBAAA;EACA,aAAA;AAKF;;AAHA;EACE,kBAAA;EACA,4BAAA;EACA,+BAAA;EACA,WAAA;EACA,iBAAA;EACA,YAAA;EACA,SAAA;EACA,gBAAA;EACA,SAAA;EACA,WAAA;EACA,WAAA;EACA,eAAA;EACA,eAAA;EACA,oBAAA;EACA,iBAAA;AAMF;AAJE;EACE,sBAAA;AAMJ;;AAMA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;AAHF;;AAKA;EACE,eAAA;AAFF;;AAIA;EACE,YAAA;AADF;;AAGA;EACE,aAAA;EACA,gBAAA;EACA,eAAA;AAAF;;AAEA;EACE,YAAA;EACA,4BAAA;EACA,mBAAA;EACA,sBAAA;AACF;;AACA;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;AAEF;;AAAA;EACE,eAAA;EACA,iBAAA;EACA,yBAAA;AAGF;;AACA;EACE,eAAA;EACA,iBAAA;EACA,cAAA;EACA,kBAAA;AAEF;;AAAA;EACE,aAAA;AAGF;AADE;EACE,eAAA;AAGJ;;AAAA;EACE,YAAA;EACA,kBAAA;EACA,cAAA;EACA,8BAAA;AAGF;;AAAA;EACE,gBAAA;EACA,mBAAA;AAGF;;AAAA;EACE,aAAA;EACA,SAAA;AAGF;AADE;EACE,WAAA;AAGJ;;AACA;EACE;IACE,aAAA;EAEF;EAAA;IACE,sBAAA;IACA,mBAAA;EAEF;EAAA;IACE,aAAA;IACA,sBAAA;IACA,mBAAA;EAEF;EAAA;IACE,gBAAA;IACA,UAAA;EAEF;EAAA;;IAEE,UAAA;IACA,WAAA;IACA,YAAA;EAEF;EAAA;IACE,mBAAA;EAEF;EAAA;IACE,uBAAA;EAEF;EADE;IACE,kBAAA;EAGJ;EAAA;IACE,uBAAA;EAEF;AACF","sourcesContent":["@import \"./../../utils/scss/variables\";\n\n.page {\n  display: flex;\n  flex-direction: column;\n  min-height: 100vh;\n  .tutorial-link {\n    position: fixed;\n    bottom: 0;\n    right: 0;\n    margin: 0 10px 25px 0;\n    height: auto;\n    a {\n      border: 1px solid chartreuse;\n      background-color: $primary-color;\n      color: white;\n      text-decoration: none;\n      font-size: 12px;\n      padding: 10px;\n    }\n  }\n}\n.main-header {\n  box-shadow: 0px 3px 5px rgba(0, 0, 0, 0.2);\n  padding: 24px 32px;\n  display: flex;\n  align-items: center;\n  position: relative;\n}\n.main-header__logo-container {\n  flex-grow: 1;\n}\n\n.main-header__logo-container__version {\n  display: block;\n}\n\n.main-header__user-area {\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n  justify-content: flex-end;\n  .line-break {\n    width: 100%;\n  }\n  button {\n    margin: 5px 5px -15px 5px;\n    background: none !important;\n    border: none;\n    color: #069;\n    font-size: 12px;\n    text-decoration: underline;\n    text-align: center;\n    cursor: pointer;\n  }\n}\n.main-header__user-area__greetings {\n  padding-right: 16px;\n}\n.main-header__user-area__user-name {\n  font-weight: bolder;\n  color: $primary-color;\n}\n.main-header__user-area__user-photo {\n  border-radius: 50%;\n  width: 52px;\n  height: 52px;\n  outline: 2px solid $primary-color;\n  outline-offset: 2px;\n}\n.content-wrapper {\n  display: flex;\n  flex-grow: 1;\n  height: calc(100% - 10px);\n}\n\n.main-container-wrapper {\n  flex-grow: 1;\n  position: relative;\n  overflow: hidden;\n  padding: 36px;\n}\n.menu-toggle-button {\n  position: absolute;\n  border-top-right-radius: 50%;\n  border-bottom-right-radius: 50%;\n  width: 72px;\n  text-indent: 32px;\n  height: 72px;\n  border: 0;\n  background: #ccc;\n  top: 40px;\n  left: -36px;\n  color: #fff;\n  font-size: 20px;\n  cursor: pointer;\n  transition: all 0.3s;\n  line-height: 72px;\n\n  &:hover {\n    background-color: #aaa;\n  }\n\n  // &.closed {\n  // }\n  // &.opened {\n  // }\n}\n// .menu-toggle-button__icon {\n// }\n// .main-container {\n// }\n.main-container__header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n.main-container__title {\n  font-size: 32px;\n}\n.main-container__search-container {\n  width: 400px;\n}\n.main-content {\n  display: flex;\n  margin-top: 24px;\n  flex-wrap: wrap;\n}\n.main-content__sidebar {\n  width: 300px;\n  border-right: 1px solid #ccc;\n  padding-right: 40px;\n  box-sizing: border-box;\n}\n.main-content__sidebar__header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n.main-content__sidebar__title {\n  font-size: 18px;\n  font-weight: bold;\n  text-transform: uppercase;\n}\n// .filters {\n// }\n.filters__title {\n  font-size: 18px;\n  font-weight: bold;\n  margin: 16px 0;\n  width: fit-content;\n}\n.checkbox.filters__checkbox {\n  display: flex;\n\n  ~ .filters__checkbox {\n    margin-top: 8px;\n  }\n}\n.main-content__result {\n  flex-grow: 1;\n  padding-left: 40px;\n  flex-shrink: 0;\n  flex-basis: calc(100% - 340px); \n\n}\n.modal-input {\n  margin-top: 24px;\n  margin-bottom: 16px;\n}\n\n.modal-buttons-container {\n  display: flex;\n  gap: 16px;\n\n  * {\n    width: 100%;\n  }\n}\n\n@media screen and (max-width: 1273px) {\n  .main-container-wrapper {\n    padding: 20px;\n  }\n  .main-content {\n    flex-direction: column;\n    align-items: center;\n  }\n  .main-container__header {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n  }\n  .main-container__search-container {\n    margin-top: 20px;\n    width: 50%;\n  }\n  .main-content__sidebar,\n  .main-content__result {\n    padding: 0;\n    width: 100%;\n    border: none;\n  }\n  .main-content__sidebar {\n    margin-bottom: 50px;\n  }\n  .main-content__sidebar__header {\n    justify-content: center;\n    h4 {\n      margin-right: 20px;\n    }\n  }\n  .checkbox.filters__checkbox {\n    justify-content: center;\n  }\n}\n","$primary-color: #0abf53;\n\n// Screen size variables\n$screen-xxs-max: 370px; // Tiny phones\n$screen-xs-max: 425px; // Tiny phones\n$screen-sm-max: 576px; // Small tablets and large smartphones (landscape view)\n$screen-md-max: 767px; // Small tablets (portrait view)\n$screen-lg-max: 1024px; // Tablets and small desktops\n$screen-upper-lg-max: 1120px; // Tablets and small desktops\n$screen-xl-max: 1440px; // Large tablets and desktops\n\n// z-index\n$z-indexes: (\"login\", \"loginFooter\", \"loginOverlay\");\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
